import request from '@/utils/request'

const api = {
  pageQuery: "/payConfig/pageQuery",
  deleteInfo: "/payConfig/deleteInfo",
  save: "/payConfig/save",
  detail:"/payConfig/detail",
  getByType:"/payConfig/getByType",
  getOneByType:"/payConfig/getOneByType",
}

export default api

export function pageQuery(data){
  return request({
    url: api.pageQuery,
    method: 'post',
    data
  })
}

export function deleteInfo(data){
  return request({
    url: api.deleteInfo,
    method: 'post',
    data
  })
}

export function save(data){
  return request({
    url: api.save,
    method: 'post',
    data
  })
}

export function detail(data){
  return request({
    url: api.detail,
    method: 'post',
    data
  })
}

export function getByType(data){
    return request({
      url: api.getByType,
      method: 'post',
      data
    })
}

export function getOneByType(data){
    return request({
      url: api.getOneByType,
      method: 'post',
      data
    })
}